/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Current_VersionInputs */



/**
* | output |
* | --- |
* | "Current version: {version}" |
*
* @param {Current_VersionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const current_version = /** @type {((inputs: Current_VersionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_VersionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Version actuelle : ${i?.version}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktuelle Version: ${i?.version}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Versione corrente: ${i?.version}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Текущая версия: ${i?.version}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Versión actual: ${i?.version}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`当前版本：${i?.version}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`現在のバージョン: ${i?.version}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वर्तमान संस्करण: ${i?.version}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Versão atual: ${i?.version}`)
	return /** @type {LocalizedString} */ (`Current version: ${i?.version}`)
});